/**
 * GeoPointCell Component
 * 
 * Renders Parse GeoPoint values with:
 * - Coordinates display: "(lat, lng)"
 * - Location pin icon
 * - Click to expand with Google Maps link
 */

import { CellRendererProps, ParseGeoPoint } from '../../../../../types/AppPanel';

export default function GeoPointCell({ 
  value, 
  onExpand 
}: CellRendererProps<ParseGeoPoint | null | undefined>) {
  // Handle null/undefined
  if (value === null) {
    return <span className="text-white/30 italic">(null)</span>;
  }
  if (value === undefined) {
    return <span className="text-white/30 italic">(undefined)</span>;
  }

  // Validate GeoPoint structure
  if (typeof value !== 'object' || 
      typeof value.latitude !== 'number' || 
      typeof value.longitude !== 'number') {
    return <span className="text-white/30 italic">(invalid geopoint)</span>;
  }

  const lat = value.latitude.toFixed(6);
  const lng = value.longitude.toFixed(6);
  
  // Truncate for display
  const displayLat = value.latitude.toFixed(4);
  const displayLng = value.longitude.toFixed(4);

  return (
    <button
      onClick={onExpand}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full 
                 bg-amber-500/20 text-amber-400 text-xs font-medium
                 hover:bg-amber-500/30 transition-colors cursor-pointer"
      title={`Lat: ${lat}, Lng: ${lng}`}
    >
      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      ({displayLat}, {displayLng})
    </button>
  );
}

